import mainVersionOneService from 'services/mainVersionOneService';

export function systemInfo(portId: number) {
    return mainVersionOneService
        .get(`pulls/${portId}/systemInfo`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function lastUpdate(portId: number) {
    return mainVersionOneService
        .get(`pulls/${portId}/0/last`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
